import React, { Component } from "react";
import {
  Text,
  View,
  Image,
  ScrollView,
  Dimensions,
  Platform,
} from "react-native";
import {
  postSingle,
  Flex,
  Padding,
  Margin,
  Helpers,
  Typo,
  article,
  pageCover,
  FontFamily,
  popularStories,
  Colors,
  button,
} from "../../styles/appStyles";
import { helpers } from "../../utils/helpers";
import PageBreak from "../page-break";
import TouchableOpacityLink from "../touchable-opacity-link";
import getImagePath from "../../utils/image-helper";
import CustomImage from "../custom-image";
import Cookies from "universal-cookie";
import AuthenticationWrapper from "../authentication-wrapper";
import TouchableOpacityLinkExternal from "../touchable-opacity-link-external";
import ButtonGradient from "../button-gradient";

const Startup = getImagePath("img/startup-img.png");
const Fintech = getImagePath("img/fintech-img.png");
const Retail = getImagePath("img/retail-img.png");
const eccomerce = getImagePath("img/eccomerce-img.png");
const media = getImagePath("img/media-img.png");

//mobile
const StartupMobImg = getImagePath("img/m-startup-img.png");
const FintechMobImg = getImagePath("img/m-fintech-img.png");
const RetailMobImg = getImagePath("img/m-retail-img.png");
const eccomerceMobImg = getImagePath("img/m-ecomerce-img.png");
const mediaMobImg = getImagePath("img/m-media-img.png");

const cookies = new Cookies();

export class HomeNewsletterCategories extends Component {
  constructor(props) {
    super(props);
    let webView = helpers.isWeb();
    // const {isAuthenticated, fetchToken} = this.props.auth
    // let token = webView ? (process.browser ? (isAuthenticated?fetchToken:false) : this.props.token) : this.props.user?.userData?.data?.token;
    this.state = {
      showToken: !helpers.isWeb() || process.browser ? true : false,
      newsletterList: [
        { name: "Startups", id: 1 },
        { name: "Public Markets", id: 2 },
        { name: "World Affairs", id: 3 },
        { name: "Love & Family", id: 4 },
        { name: "Technology", id: 5 },
        { name: "Agriculture", id: 6 },
        { name: "Economy", id: 7 },
        { name: "Science", id: 8 },
        { name: "Public Policy", id: 9 },
        { name: "Environment", id: 10 },
        { name: "Sports", id: 11 },
      ],
    };
  }

  componentDidMount = () => {};

  trackThemeClick = (theme) => {
    console.log("theme");
    if (this.props.trackThemeClick) {
      this.props.trackThemeClick(theme);
    }
  };

  methodProps = (i) => {
    let agricultureProp,
      economyProp,
      sportsProp,
      scienceProp,
      startupprops,
      publicMarketProps,
      worldProps,
      loveProps,
      technologyProps,
      policyProps,
      environmentProp;

    if (helpers.isWeb()) {
      agricultureProp = {
        to: "/tag/agriculture?newsletter=true&newsletter_slug=from-fork-to-farm",
      };
      sportsProp = {
        to: "/tag/sports?newsletter=true&newsletter_slug=game-point",
      };
      economyProp = {
        to: "/tag/economy?newsletter=true&newsletter_slug=peoples-economics",
      };
      environmentProp = {
        to: "/tag/environment?newsletter=true&newsletter_slug=the-crucial-years,thirty-six",
      };
      scienceProp = {
        to: "/tag/science?newsletter=true&newsletter_slug=the-world-revealed",
      };
      startupprops = {
        to: "/tag/startups?newsletter=true&newsletter_slug=things-change",
      };
      publicMarketProps = {
        to: "/tag/public-markets?newsletter=true&newsletter_slug=street-smart",
      };
      worldProps = {
        to: "/tag/world-affairs?newsletter=true&newsletter_slug=antiloquy",
      };
      loveProps = {
        to: "/tag/love-family?newsletter=true&newsletter_slug=notes-from-natasha",
      };
      technologyProps = {
        to: "/tag/technology?newsletter=true&newsletter_slug=techlawlogy, oversize",
      };
      policyProps = {
        to: "/tag/public-policy?newsletter=true&newsletter_slug=creative-destruction",
      };
    } else {
      agricultureProp = {
        onPress: () => getTagClick("agriculture"),
      };
      sportsProp = {
        onPress: () => getTagClick("sports"),
      };
      economyProp = {
        onPress: () => getTagClick("economy"),
      };
      environmentProp = {
        onPress: () => getTagClick("environment"),
      };
      scienceProp = {
        onPress: () => getTagClick("science"),
      };
      startupprops = {
        onPress: () => getTagClick("startups"),
      };
      publicMarketProps = {
        onPress: () => getTagClick("public-markets"),
      };
      worldProps = {
        onPress: () => getTagClick("world-affairs"),
      };
      loveProps = {
        onPress: () => getTagClick("love-family"),
      };
      technologyProps = {
        onPress: () => getTagClick("technology"),
      };
      policyProps = {
        onPress: () => getTagClick("public-policy"),
      };
    }

    if (i == 1) {
      return startupprops;
    } else if (i == 2) {
      return publicMarketProps;
    } else if (i == 3) {
      return worldProps;
    } else if (i == 4) {
      return loveProps;
    } else if (i == 5) {
      return technologyProps;
    } else if (i == 6) {
      return agricultureProp;
    } else if (i == 7) {
      return economyProp;
    } else if (i == 8) {
      return scienceProp;
    } else if (i == 9) {
      return policyProps;
    } else if (i == 10) {
      return environmentProp;
    } else if (i == 11) {
      return sportsProp;
    }
  };

  render() {
    const {
      transparentBg,
      data,
      subscription,
      loggedOut,
      getTagClick,
      darkMode,
    } = this.props;
    let btnClickNewsletter, btnClickSignUp;
    let webView = helpers.isWeb();
    if (helpers.isWeb()) {
      btnClickSignUp = {
        href: "/sign-up",
      };
    } else {
      btnClickSignUp = {
        onPress: () => navigateApp("/sign-up"),
      };
    }
    if (helpers.isWeb()) {
      btnClickNewsletter = {
        href: "/newsletters",
      };
    } else {
      btnClickNewsletter = {
        onPress: () => navigateApp("/newsletters"),
      };
    }
    return (
      <View
        style={[
          Margin.mb_3,
          helpers.isDesktop() && { alignSelf: "center" },
          !helpers.isDesktop() && { alignItems: "center" },
          {
            backgroundColor: transparentBg
              ? "transparent"
              : darkMode
              ? Colors.darkBlackColorBg
              : "#FFF",
          },
        ]}
      >
        <View
          style={[
            helpers.isDesktop() && {
              marginLeft: "auto",
              marginRight: "auto",
            },
            Padding.pt_3,
          ]}
        >
          {!subscription && (
            <View style={[Flex.alignCenter]}>
              <View
                style={[
                  Helpers.titleBgWrap,
                  { backgroundColor: "transparent" },
                ]}
              >
                <Text
                  style={[
                    Helpers.textCenter,
                    Typo.h3_R,
                    helpers.isDesktop() && Typo.h3_RDesktop,
                    Margin.mb_0,
                    { fontFamily: FontFamily.abrilFatface },
                    { fontSize: helpers.isDesktop() ? 34 : 24 },
                    !helpers.isDesktop() && {
                      lineHeight: 36,
                      paddingBottom: 6,
                    },
                    {
                      color: darkMode
                        ? "rgba(255,255,255,0.87)"
                        : helpers.isDesktop()
                        ? "000"
                        : "#051462",
                    },
                  ]}
                >
                  {data.title}
                </Text>
              </View>
            </View>
          )}
        </View>
        <View
          style={[
            helpers.isDesktop() && Padding.ph_2,
            Helpers.conatinerWeb,
            { flexDirection: "row", flexWrap: "wrap", alignItems: "center" },
            helpers.isDesktop() && Helpers.conatinerWebFull,
            helpers.isDesktop() && Margin.mt_2,
            helpers.isDesktop() && { justifyContent: "center", maxWidth: 1100 },
            !helpers.isDesktop() && { justifyContent: "center" },
          ]}
        >
          {subscription && (
            <View
              style={[
                {
                  borderWidth: 1,
                  borderColor: "#7B8FFE",
                  borderRadius: 30,
                  backgroundColor: "#fff",
                },
                helpers.isDesktop() && { margin: 10 },
              ]}
            >
              <View
                style={[
                  Flex.alignCenter,
                  helpers.isDesktop() && Margin.mb_7,
                  !helpers.isDesktop() && Margin.mb_4,
                  {
                    width: helpers.isWeb() ? "fit-content" : "100%",
                    marginLeft: "auto",
                    marginRight: "auto",
                  },
                ]}
              >
                <View
                  style={[
                    Padding.ph_2,
                    Helpers.titleBgWrap,
                    { backgroundColor: "transparent" },
                  ]}
                >
                  <Text
                    style={[
                      Helpers.textCenter,
                      Typo.h3_R,
                      helpers.isDesktop() && Typo.h3_RDesktop,
                      Margin.mb_0,
                      { fontFamily: FontFamily.abrilFatface },
                      {
                        fontSize: helpers.isDesktop() ? 24 : 18,
                        color: "#7B8FFE",
                      },
                      darkMode && { color: "rgba(255,255,255,0.87)" },
                      { paddingHorizontal: 10, paddingVertical: 0 },
                    ]}
                  >
                    {data.title}
                  </Text>
                </View>
              </View>
            </View>
          )}

          {this.state.newsletterList &&
            this.state.newsletterList.map((d, i) => {
              return (
                <View
                  style={[
                    !helpers.isDesktop() && { padding: 10 },
                    helpers.isDesktop() && { margin: 10 },
                  ]}
                  key={`newsletter_home_${i}`}
                >
                  <TouchableOpacityLink
                    {...this.methodProps(d.id)}
                    handleClick={() =>
                      this.trackThemeClick(
                        d.id == 1
                          ? "internet"
                          : d.id == 2
                          ? "business"
                          : d.id == 3
                          ? "chaos"
                          : d.id == 4
                          ? "sports"
                          : "economics"
                      )
                    }
                  >
                    <View
                      style={[
                        {
                          borderWidth: 1,
                          borderColor: "#7B8FFE",
                          borderRadius: 30,
                          backgroundColor: "#fff",
                        },
                        !helpers.isDesktop() && {
                          paddingBottom: 0,
                          marginLeft: 0,
                          marginRight: 0,
                        },
                        !process.browser && { width: 300 },
                        !helpers.isWeb() && { width: "100%" },
                        darkMode && { backgroundColor: "#1E1E1E" },
                      ]}
                    >
                      <View
                        style={[
                          Flex.row,
                          Flex.alignCenter,
                          Flex.justifyBetween,
                          { alignItems: "baseline" },
                          !webView && { alignItems: "center" },
                        ]}
                      >
                        <Text
                          style={[
                            popularStories.imageTitle,
                            helpers.isDesktop() &&
                              popularStories.imageTitleDesktop,
                            { color: "#7B8FFE" },
                            darkMode && { color: "rgba(255,255,255,0.87)" },
                            { paddingHorizontal: 20, paddingVertical: 0 },
                            !helpers.isDesktop() && {
                              fontSize: 14,
                              lineHeight: 25,
                              fontWeight: 400,
                            },
                          ]}
                        >
                          {d.name}
                        </Text>
                      </View>
                    </View>
                  </TouchableOpacityLink>
                </View>
              );
            })}

          {/* <View
            style={[
              !helpers.isDesktop() && { padding: 10 },
              helpers.isDesktop() && { margin: 10 },
            ]}
          >
            <TouchableOpacityLink
              {...internetProp}
              handleClick={() => this.trackThemeClick("internet")}
            >
              <View
                style={[
                  {
                    borderWidth: 1,
                    borderColor: "#7B8FFE",
                    borderRadius: 30,
                    backgroundColor: "#fff",
                  },
                  !helpers.isDesktop() && {
                    paddingBottom: 0,
                    marginLeft: 0,
                    marginRight: 0,
                  },
                  !process.browser && { width: 300 },
                  !helpers.isWeb() && { width: "100%" },
                  darkMode && { backgroundColor: "#1E1E1E" },
                ]}
              >
                <View
                  style={[
                    Flex.row,
                    Flex.alignCenter,
                    Flex.justifyBetween,
                    { alignItems: "baseline" },
                    !webView && { alignItems: "center" },
                  ]}
                >
                  <Text
                    style={[
                      popularStories.imageTitle,
                      helpers.isDesktop() && popularStories.imageTitleDesktop,
                      { color: "#7B8FFE" },
                      darkMode && { color: "rgba(255,255,255,0.87)" },
                      { paddingHorizontal: 20, paddingVertical: 0 },
                      !helpers.isDesktop() && {
                        fontSize: 14,
                        lineHeight: 25,
                        fontWeight: 400,
                      },
                    ]}
                  >
                    Agriculture
                  </Text>
                </View>
              </View>
            </TouchableOpacityLink>
          </View>

          <View
            style={[
              !helpers.isDesktop() && { padding: 10 },
              helpers.isDesktop() && { margin: 10 },
            ]}
          >
            <TouchableOpacityLink
              {...businessProp}
              handleClick={() => this.trackThemeClick("business")}
            >
              <View
                style={[
                  {
                    borderWidth: 1,
                    borderColor: "#7B8FFE",
                    borderRadius: 30,
                    backgroundColor: "#fff",
                  },
                  !helpers.isDesktop() && {
                    paddingBottom: 0,
                    marginLeft: 0,
                    marginRight: 0,
                  },
                  !process.browser && { width: 300 },
                  !helpers.isWeb() && { width: "100%" },
                  darkMode && { backgroundColor: "#1E1E1E" },
                ]}
              >
                <View
                  style={[
                    Flex.row,
                    Flex.alignCenter,
                    Flex.justifyBetween,
                    { alignItems: "baseline" },
                    !webView && { alignItems: "center" },
                  ]}
                >
                  <Text
                    style={[
                      popularStories.imageTitle,
                      helpers.isDesktop() && popularStories.imageTitleDesktop,
                      { color: "#7B8FFE" },
                      darkMode && { color: "rgba(255,255,255,0.87)" },
                      { paddingHorizontal: 20, paddingVertical: 0 },
                      !helpers.isDesktop() && {
                        fontSize: 14,
                        lineHeight: 25,
                        fontWeight: 400,
                      },
                    ]}
                  >
                    Sports
                  </Text>
                </View>
              </View>
            </TouchableOpacityLink>
          </View>
          <View
            style={[
              !helpers.isDesktop() && { padding: 10 },
              helpers.isDesktop() && { margin: 10 },
            ]}
          >
            <TouchableOpacityLink
              {...chaosProp}
              handleClick={() => this.trackThemeClick("chaos")}
            >
              <View
                style={[
                  {
                    borderWidth: 1,
                    borderColor: "#7B8FFE",
                    borderRadius: 30,
                    backgroundColor: "#fff",
                  },
                  !helpers.isDesktop() && {
                    paddingBottom: 0,
                    marginLeft: 0,
                    marginRight: 0,
                  },
                  !process.browser && { width: 300 },
                  !helpers.isWeb() && { width: "100%" },
                  darkMode && { backgroundColor: "#1E1E1E" },
                ]}
              >
                <View
                  style={[
                    Flex.row,
                    Flex.alignCenter,
                    Flex.justifyBetween,
                    { alignItems: "baseline" },
                    !webView && { alignItems: "center" },
                  ]}
                >
                  <Text
                    style={[
                      popularStories.imageTitle,
                      helpers.isDesktop() && popularStories.imageTitleDesktop,
                      { color: "#7B8FFE" },
                      darkMode && { color: "rgba(255,255,255,0.87)" },
                      { paddingHorizontal: 20, paddingVertical: 0 },
                      !helpers.isDesktop() && {
                        fontSize: 14,
                        lineHeight: 25,
                        fontWeight: 400,
                      },
                    ]}
                  >
                    Economy
                  </Text>
                </View>
              </View>
            </TouchableOpacityLink>
          </View>
          <View
            style={[
              !helpers.isDesktop() && { padding: 10 },
              helpers.isDesktop() && { margin: 10 },
            ]}
          >
            <TouchableOpacityLink
              {...scienceProp}
              handleClick={() => this.trackThemeClick("sports")}
            >
              <View
                style={[
                  {
                    borderWidth: 1,
                    borderColor: "#7B8FFE",
                    borderRadius: 30,
                    backgroundColor: "#fff",
                  },
                  !helpers.isDesktop() && {
                    paddingBottom: 0,
                    marginLeft: 0,
                    marginRight: 0,
                  },
                  !process.browser && { width: 300 },
                  !helpers.isWeb() && { width: "100%" },
                  darkMode && { backgroundColor: "#1E1E1E" },
                ]}
              >
                <View
                  style={[
                    Flex.row,
                    Flex.alignCenter,
                    Flex.justifyBetween,
                    { alignItems: "baseline" },
                    !webView && { alignItems: "center" },
                  ]}
                >
                  <Text
                    style={[
                      popularStories.imageTitle,
                      helpers.isDesktop() && popularStories.imageTitleDesktop,
                      { color: "#7B8FFE" },
                      darkMode && { color: "rgba(255,255,255,0.87)" },
                      { paddingHorizontal: 20, paddingVertical: 0 },
                      !helpers.isDesktop() && {
                        fontSize: 14,
                        lineHeight: 25,
                        fontWeight: 400,
                      },
                    ]}
                  >
                    Science
                  </Text>
                </View>
              </View>
            </TouchableOpacityLink>
          </View>
          <View
            style={[
              !helpers.isDesktop() && { padding: 10 },
              helpers.isDesktop() && { margin: 10 },
            ]}
          >
            <TouchableOpacityLink
              {...environmentProp}
              handleClick={() => this.trackThemeClick("economics")}
            >
              <View
                style={[
                  {
                    borderWidth: 1,
                    borderColor: "#7B8FFE",
                    borderRadius: 30,
                    backgroundColor: "#fff",
                  },
                  !helpers.isDesktop() && {
                    paddingBottom: 0,
                    marginBottom: 0,
                    marginLeft: 0,
                    marginRight: 0,
                  },
                  !process.browser && { width: 300 },
                  !helpers.isWeb() && { width: "100%" },
                  darkMode && { backgroundColor: "#1E1E1E" },
                ]}
              >
                <View
                  style={[
                    Flex.row,
                    Flex.alignCenter,
                    Flex.justifyBetween,
                    { alignItems: "baseline" },
                    !webView && { alignItems: "center" },
                  ]}
                >
                  <Text
                    style={[
                      popularStories.imageTitle,
                      helpers.isDesktop() && popularStories.imageTitleDesktop,
                      { color: "#7B8FFE" },
                      darkMode && { color: "rgba(255,255,255,0.87)" },
                      { paddingHorizontal: 20, paddingVertical: 0 },
                      !helpers.isDesktop() && {
                        fontSize: 14,
                        lineHeight: 25,
                        fontWeight: 400,
                      },
                    ]}
                  >
                    Environment
                  </Text>
                </View>
              </View>
            </TouchableOpacityLink>
          </View> */}
        </View>
        {loggedOut ? (
          <View
            style={
              ([helpers.isDesktop() && Flex.row, Margin.mh_5],
              { alignSelf: "center", marginTop: 20 })
            }
          >
            <TouchableOpacityLinkExternal {...btnClickSignUp} newTab={true}>
              <ButtonGradient
                title={"SIGN UP TO SUBSCRIBE"}
                rootStyle={{
                  btnWrapper: [button.primaryGradient, { height: 50 }],
                  btnText: [
                    button.primaryGradientText,
                    {
                      fontSize: 16,
                      paddingHorizontal: 45,
                      fontWeight: "600",
                      fontFamily: FontFamily.regular,
                    },
                  ],
                }}
                paddingOverride={true}
                onClick={() => {}}
                darkMode={darkMode}
              />
            </TouchableOpacityLinkExternal>
          </View>
        ) : (
          <View
            style={
              ([helpers.isDesktop() && Flex.row, Margin.mh_3],
              { alignSelf: "center", marginTop: 20 })
            }
          >
            <TouchableOpacityLinkExternal {...btnClickNewsletter} newTab={true}>
              <ButtonGradient
                title={"VIEW ALL NEWSLETTERS"}
                rootStyle={{
                  btnWrapper: [button.primaryGradient, { height: 55 }],
                  btnText: [
                    button.primaryGradientText,
                    {
                      fontSize: 17,
                      paddingHorizontal: 35,
                      fontWeight: "600",
                      fontFamily: FontFamily.regular,
                    },
                  ],
                }}
                paddingOverride={true}
                onClick={() => {}}
                darkMode={darkMode}
              />
            </TouchableOpacityLinkExternal>
          </View>
        )}
      </View>
    );
  }
}

export default AuthenticationWrapper(HomeNewsletterCategories);
